import { EventAttendee } from './event-attendee';

export interface EventsAttendees {
  attendees: EventAttendee[];
  yearToDateAttendance: number;
}
